export const testimonialsData = [
  {
    id: 1,
    name: "Ahmed Al-Rashid",
    role: "Homeowner, Lahore",
    text: "M. Hayat & Co. crafted our entire home\u2019s furniture and it transformed every room into a palace. The attention to detail in each carved piece is extraordinary. Three generations of my family have trusted this brand, and the quality only gets better.",
    rating: 5,
    avatar: "https://readdy.ai/api/search-image?query=professional%20middle%20eastern%20man%20portrait%20confident%20warm%20smile%20business%20attire%20neutral%20background%20high%20quality%20photograph&width=80&height=80&seq=tes1&orientation=squarish",
  },
  {
    id: 2,
    name: "Nadia Malik",
    role: "Interior Designer, Karachi",
    text: "As an interior designer, I\u2019ve worked with furniture brands worldwide. None compare to M. Hayat & Co.\u2019s craftsmanship. Their heritage pieces are genuinely unique \u2013 you can feel the 150 years of expertise in every joint, every finish, every detail.",
    rating: 5,
    avatar: "https://readdy.ai/api/search-image?query=professional%20south%20asian%20woman%20portrait%20warm%20smile%20elegant%20neutral%20background%20high%20quality%20photograph%20confident&width=80&height=80&seq=tes2&orientation=squarish",
  },
  {
    id: 3,
    name: "Tariq Hussain",
    role: "Businessman, Islamabad",
    text: "I ordered a custom executive office set and dining room suite. The team understood my vision perfectly and delivered pieces that will last generations. The durability, the design, and the service \u2013 all world-class. This is heirloom-quality furniture.",
    rating: 5,
    avatar: "https://readdy.ai/api/search-image?query=professional%20pakistani%20man%20portrait%20confident%20business%20attire%20warm%20lighting%20neutral%20background%20high%20quality%20photograph&width=80&height=80&seq=tes3&orientation=squarish",
  },
  {
    id: 4,
    name: "Fareeha Khan",
    role: "Homemaker, Faisalabad",
    text: "Our bedroom set from M. Hayat & Co. is simply breathtaking. My grandmother pointed to a similar piece in an old family photo from the 1940s \u2013 that\u2019s how timeless their design language is. The wood quality and finishing is incomparable.",
    rating: 5,
    avatar: "https://readdy.ai/api/search-image?query=south%20asian%20woman%20portrait%20elegant%20warm%20smile%20neutral%20background%20high%20quality%20photograph&width=80&height=80&seq=tes4&orientation=squarish",
  },
];
